<style lang="less" scoped>
    .workInfowrap{
        margin: 0 15px;
        background: #FBF6F6;
        .titlewrap{
            background: #fff;
            padding-top: 28px;
            .title{
                font-size:40px;
                color: #333440;
                .xzcolor{
                    color: rgba(239,75,75,1);
                }
                .state{
                    background: #F3A117;
                    border-radius: 2px;
                    font-size:20px;
                    color: #FFFFFF;
                    text-align: center;
                    width: 88px;
                    height: 36px;
                    line-height: 36px;
                    display: inline-block;
                }
            }
            .infobox{
                padding-bottom: 32px;
                margin-left:-50px;
                margin-top:16px;
                span{
                    margin-left: 50px;
                    color:#5B5C66;
                    font-size:24px;
                    display: inline-block;
                    height: 32px;
                    line-height: 32px;

                }
                i{
                    width: 32px;
                    height: 32px;
                    display: inline-block;
                    vertical-align: bottom;
                    margin-right: 12px;
                }
                .sitespan{
                    background: url("../images/dw.png") no-repeat;
                    background-size: 100% 100%;
                }
                .yearspan{
                    background: url("../images/nx.png") no-repeat;
                    background-size: 100% 100%;
                }
                .recordspan{
                    background: url("../images/xl.png") no-repeat;
                    background-size: 100% 100%;
                }
                .workspan{
                    background: url("../images/qz.png") no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
        .companywrap{
           background: #fff; 
           margin-top: 20px;
           img{
               width: 100px;
               height: 100px;
               margin: 28px 0;
           }
           .infobox{
               margin-left:20px;
               .title{
                    margin-top:50px;
                    font-size: 28px;
                    color: #5B5C66;
               }
           }
            .jiantou:after{
                margin-top: 72px;
                margin-right:48px;
                border: 2px solid #c8c8cd;
                border-bottom-width: 0;
                border-left-width: 0;
                content: " ";
                width:20px;
                height:20px;
                -webkit-transform: translateY(-50%) rotate(45deg);
                transform: translateY(-50%) rotate(45deg);
                display: block;
            }
        }
        .pb100{
            margin-bottom: 100px;
        }
        .workinfo{
            margin-top:20px;
            background: #fff;
            h3{
                height: 82px;
                line-height: 82px;
                border-bottom: 1px solid #EFEFEF;
            }
            span{
                
                width: 32px;
                height: 32px;
                display: inline-block;
                vertical-align: sub;
                margin-right: 12px;
            }
            .ms{
                background: url("../images/zwms.png") no-repeat;
                background-size: 100% 100%;
            }
            .yq{
                background: url("../images/zwsq.png") no-repeat;
                background-size: 100% 100%;
            }
            .content{
                padding:28px 0;
                font-size:26px;
                line-height:32px;
                color: #5B5C66;
            }
        }
        .btnbox{
            position:fixed;
            bottom:0;
            left: 0;
            width: 100%;
            background: #fff;
            padding: 10px 0;
            span{
                width: 332px;
                height: 80px;
                line-height: 80px;
                text-align: center;
                margin-left: 26px;
                font-size:30px;
                color: #A4A4A4;
                box-shadow: 4px 8px 20px 0 rgba(239,75,75,0.27);
            }
            span.sc i{
                width: 42px;
                height: 42px;
                display: inline-block;
                background: url("../images/sc.png") no-repeat;
                background-size: 100% 100%;
                vertical-align: sub;
                margin-right:10px;
                
            }
            span.td{
                background-image: linear-gradient(-90deg, #EF4B4B 0%, #F7643C 100%);
                border-radius: 8px;
                color: #fff;
            }
            .calbtn{
                
                border-radius:8px;
                font-size:30px;
                color: #EF4B4B;
                height: 80px;
                line-height: 80px;
                text-align: center;
                width: 690px;
                margin: 0 auto;
                border:2px solid #EF4B4B;
            }
        }
        .popupwrap{
            width:480px;
            height:184px;
            font-size: 36px;
            color: #5B5C66;
            text-align: center;
            padding-top:30px;
            span{
                margin-top:20px;
                display: inline-block;
                color: #3da8f5;
            }
        }
    }
</style>

<template>
    <!-- 职位详情 -->
    <div class="workInfowrap">
      <div class="titlewrap">
          <p class="title">{{infodata.advertisePosition}}<span class="xzcolor">【{{infodata.demandPrice}}】</span><span v-if="infodata.isOneself=='1'" class="state">已发布</span></p>
          <p class="infobox">
              <span><i class="sitespan"></i>{{infodata.address}}</span>
              <span><i class="yearspan"></i>{{infodata.experience}}</span>
              <!-- <span><i class="recordspan"></i>{{infodata.experience}}</span> -->
          </p>
      </div>
      <div class="companywrap clearfix" @click="linkpageFn">
          <img :src="infodata.companyLogo?infodata.companyLogo:require('../images/default.jpg')" alt="" class="fl">
          <div class="fl infobox">
              <p class="title">{{infodata.companyName}}</p>
          </div>
          <i class="fr jiantou"></i>
      </div>
      <div class="workinfo">
          <h3><span class="ms"></span> 职位描述</h3>
          <div class="content">{{infodata.positionExplain}}</div>
      </div>
      <div class="workinfo pb100">
          <h3><span class="yq"></span> 职位要求</h3>
          <div class="content">{{infodata.positionDemand}}</div>
      </div>
      <div class="btnbox" v-if="btnboxflag">
          <div class="clearfix" v-if="infodata.isOneself=='2'">
                <span class="fl sc" @click="scFn"><i v-if="infodata.isCollect"></i>{{infodata.isCollect?'已收藏':'收藏'}}</span>
                <span class="fl td" @click="tdFn">投递简历</span>
          </div>
          <div v-else class="calbtn" @click="calFn">取消职位</div>
      </div>
      <mt-popup v-model="popupVisible">
        <div class="popupwrap">请投递简历至邮箱<span>{{infodata.companyMail}}</span></div>
      </mt-popup>
    </div>
</template>

<script>
import { MessageBox,Indicator } from 'mint-ui';
import global from "../js/global.js"
export default {
  data () {
    return {
        popupVisible:false,
        infodata:{},
        btnboxflag:true,
        token:""
    }
  },
  created(){
    this.init();
  },
  mounted(){
    window.getToken = this.getToken;
    if(global.getmobiletype()=="android"){
        this.token = control.getToken()
    }
    else{        
        window.webkit.messageHandlers.getToken.postMessage({"mothedName":"getToken"});             
    }
  },
  methods:{
    linkpageFn(){
        if(global.getmobiletype()=="android"){
            control.goNewPageWithShare(
                global.ipHeader+"/companyInfo?contentId="+this.infodata.companyId+"&accountId="+this.$route.query.accountId,
                "公司详情",
                this.infodata.companyId,
                1
            )
        }
        else{
            window.webkit.messageHandlers.openNewWebViewWithNewNav.postMessage(
                {
                    "url":global.ipHeader+"/companyInfo?contentId="+this.infodata.companyId+"&accountId="+this.$route.query.accountId,
                    "webTitle":"公司详情",
                    'contentId':this.infodata.companyId,
                    'dataType':'1',
                    "mothedNameArr":["getToken","openRequirementTypeVCWithCompanyId","openRecruitTypeVCWithCompanyId"]
                }
            );
        }
    },
    getToken(token){
        this.token = token;
    },
    init(){
        // this.$http.get("/content/advertise/detail/query?advertiseId="+"5a7d135010d82414f03bacdf"+"&accountId=75")
        this.$http.get("/content/advertise/detail/query?advertiseId="+this.$route.query.contentId+"&accountId="+this.$route.query.accountId)
		.then((response) => {
            this.infodata = response.respData
		});
    },
    tdFn(){
        this.popupVisible=true;
    },
    scFn(){
        Indicator.open();
        // this.$http.post("/content/collection?contentId="+"5a7d135010d82414f03bacdf"+"&accountId=32"+"&contentType="+3,"",{headers:{"Authorization":"bearer 771990739267d3a2b493818b8f397adf"}})
        this.$http.post("/content/collection?contentId="+this.$route.query.contentId+"&accountId="+this.$route.query.accountId+"&contentType="+3,"",{headers:{"Authorization":"bearer "+this.token+""}})
        .then((response) => {
            Indicator.close();
            this.$toast(response.respMsg);
            this.infodata.isCollect=!this.infodata.isCollect;
        });
    },
    calFn(){
        Indicator.open();
        // this.$http.post("/content/advertise/cancel?advertiseId="+"5a7d135010d82414f03bacdf"+"&contentType="+3,"",{headers:{"Authorization":"bearer 771990739267d3a2b493818b8f397adf"}})
        this.$http.post("/content/advertise/cancel?advertiseId="+this.$route.query.contentId+"&contentType="+3,"",{headers:{"Authorization":"bearer "+this.token+""}})
        .then((response) => {
            Indicator.close();
            this.$toast('取消成功');
            this.btnboxflag=false;
            if(global.getmobiletype()=="android"){
                control.close()
            }
            else{
                window.webkit.messageHandlers.reloadRecruitTypeVCWithJobType.postMessage(this.infodata.JobTypeId);
                window.webkit.messageHandlers.popViewToControllerWithLevelNum.postMessage('1');                
            }    
        });
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/pages/workInfo.vue